import { GoogleSheetsDetailPage } from '@pwa/components/integrations/google-sheets-detail-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/org/$orgId/integrations/google-sheets/$integrationId')({
	component: RouteComponent,
});

function RouteComponent() {
	const { orgId, integrationId } = Route.useParams();
	return <GoogleSheetsDetailPage orgId={orgId} integrationId={integrationId} />;
}
